import { PDFViewer /*pdf*/ } from "@react-pdf/renderer";
import React, { useState, useEffect } from "react";
import { DistributionDoc } from "./DistributionDoc";
import { DistributionDocHTML } from "./DistributionDocHTML";

export const SourceMedSourcesList = (props) => {
  const [showDistChain, setSHowDistChain] = useState(false);

  const [useHTML, setUseHTML] = useState(true);

  useEffect(() => {
    // let isMobile = !!navigator.userAgent.match(
    //   /Android|webOS|iPhone|iPod|Blackberry/i
    // // );
    // console.log(navigator)
    // let isIos = !!navigator.userAgent.match(/iPhone|iPod|iPad/i);
    // //let isChrome = !!navigator.userAgent.match(/Chrome/i);
    // setUseHTML(isIos);

    //TODO feature detection PDF
    console.log(navigator);
  }, []);

  // async function showPDFChrome() {
  //   const distPDF = await pdf(
  //     <DistributionDoc
  //       batchId={props.summary.batchId}
  //       mfrDate={props.summary.date}
  //       data={props.summary.distData}
  //       salesData={props.summary.salesData}
  //       title={true}
  //     />
  //   ).toString();

  //   console.log(distPDF);
  // }

  return props.data ? (
    showDistChain ? (
      <div style={{ padding: "10px" }}>
        <h4>Distribution Chain Information</h4>

        {useHTML ? (
          <>
            <DistributionDocHTML
              salesData={props.salesData}
              batchId={props.batchId}
              mfrDate={props.mfrDate}
              data={props.data}
              notSM={props.notSM}
            />

            <div>Prefer a PDF view?</div>
            <button
              onClick={() => setUseHTML(false)}
              style={{ color: "white", margin: "8px" }}
            >
              View As PDF
            </button>
          </>
        ) : (
          <>
            <PDFViewer width={1000} height={500}>
              <DistributionDoc
                salesData={props.salesData}
                batchId={props.batchId}
                mfrDate={props.mfrDate}
                data={props.data}
                notSM={props.notSM}
              />
            </PDFViewer>

            <div>Prefer the original view?</div>
            <button
              onClick={() => setUseHTML(true)}
              style={{ color: "white", margin: "8px" }}
            >
              Original View
            </button>
          </>
        )}

        <div>
          If you would like to download this document please scroll down and
          click "Download as 1 PDF" to download and view the document.
        </div>
        <br />
        <button
          onClick={() => setSHowDistChain(false)}
          style={{ color: "white", margin: "8px" }}
        >
          Hide Distribution Chain
        </button>
      </div>
    ) : (
      <button
        onClick={() => setSHowDistChain(true)}
        style={{ color: "white", margin: "8px" }}
      >
        Show Distribution Chain
      </button>
    )
  ) : (
    ""
  );
};
